// Refactoring High Order Component (Komponen Paling Utama)
import React, {Component, createContext} from 'react';
import { sessCode } from './config';

const RootContext = createContext();
const Provider = RootContext.Provider;

const GlobalProvider = (Children) => {
    return (
        class ParentComp extends Component {

            state = {
                user: undefined,
                theme: "light",
                sider: false,
                page: {
                    active: "/",
                    menu: ["content"],
                },
                dim: {}
            }

            componentDidMount = () => {
                this.eventHandlers.resize();
                window.addEventListener('resize', this.eventHandlers.resize, false);
            }

            componentWillUnmount = () => {
                window.removeEventListener('resize', this.eventHandlers.resize, false);
            }

            eventHandlers = {
                resize: () => {
                    let { dim } = this.state;
                    dim.height = window.innerHeight;
                    dim.width = window.innerWidth;
                    dim.mobile = window.innerWidth <= 991 ? true : false;
                    this.setState({dim});
                },
            }

            dispatch = (action) => {
                const { theme } = this.state;
                const acted = new Promise((resolve, reject) => {
                    try {
                        if (action.type === 'SET_AUTH') {
                            return this.setState({
                                user: action.user,
                                server: action.server
                            }, () => resolve(this.state.user));
                        }
                        if (action.type === 'UNSET_AUTH') {
                            return this.setState({
                                user: undefined,
                            }, () => {
                                localStorage.removeItem(sessCode);
                                resolve(this.state.user);
                            });
                        }
                        if (action.type === 'CHANGE_THEME') {
                            return this.setState({
                                theme: theme === 'dark' ? 'light' : 'dark',
                            }, () => resolve(this.state.theme));
                        }
                        if (action.type === 'SET_SIDER') {
                            return this.setState({ sider: action.sider }, () => resolve(this.state.sider));
                        }
                        if (action.type === 'SET_PAGE') {
                            const page = {
                                ...this.state.page,
                                active: action.active
                            }
                            return this.setState({ page }, () => resolve(this.state.page));
                        }
                        if (action.type === 'SET_MENU') {
                            const page = {
                                ...this.state.page,
                                menu: action.menu
                            }
                            return this.setState({ page }, () => resolve(this.state.page));
                        }
                    }
                    catch (error) {
                        reject(error);
                    }
                });
                return acted;
            }

            render () {
                return (
                    <Provider value={{
                        state: this.state,
                        dispatch: this.dispatch,
                    }}>
                        <Children {...this.props} />
                    </Provider>
                )
            }
        }
    )
}

export default GlobalProvider;

const Consumer = RootContext.Consumer;
export const GlobalConsumer = (Children) => {
    return (
        class ParentConsumer extends Component {
            render () {
                return (
                    <Consumer>
                        {
                            value => {
                                return (
                                    <Children {...this.props} {...value} />
                                )
                            }
                        }
                    </Consumer>
                )
            }
        }
    )
}
